import { useSelector } from 'react-redux'

// Selectors
import {
  selectInsuranceModuleEnabled,
  selectLoading
} from 'src/store/selectors/homeInsurance'
import { useTrackHomeEventOnce } from 'src/hooks'

// Components

// Utils
import { HOME_INSURANCE_PANEL_VIEW_EVENT } from 'src/constants/client/events'

const useHomeInsurance = () => {
  const shouldRender = useSelector(selectInsuranceModuleEnabled)
  const loading = useSelector(selectLoading)
  useTrackHomeEventOnce(HOME_INSURANCE_PANEL_VIEW_EVENT)

  return { shouldRender, loading }
}

export default useHomeInsurance
